/**
 * PageLoader - Loading indicator for lazy-loaded pages
 * Displays during code-split chunk loading
 */
export default function PageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-secondary">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-theme-secondary border-t-primary-600 dark:border-t-primary-400" role="status" aria-label="Loading page">
          <span className="sr-only">Loading...</span>
        </div>
        <p className="mt-4 text-sm text-theme-tertiary">Loading page...</p>
      </div>
    </div>
  );
}
